import { UserManager } from 'oidc-client-ts';

//base url https://idp.rsl.org.ls/oauth2/token or node env override


  let userManager;

  function getUserManager() {
    return userManager;
  }

  function setupUserManager(baseUrl: string, newSettings: any) {

    const settings = getSettings(baseUrl);
    userManager = new UserManager({ ...settings, ...newSettings });
  }

  function getSettings(baseUrl: string) {
    const origin = typeof window !== 'undefined' ? window.location.origin : '';
    return {
      authority: `${baseUrl}/oauth2/token`, // Use baseUrl for OIDC provider's URL
      client_id: 'replaceMe', // Replace with your client ID
      redirect_uri: `${origin}/no-auth/user/signin-callback`,
      popup_redirect_uri: `${origin}/no-auth/user/signin-callback`,
      scope: 'openid profile email', // Replace with the scopes you need
      post_logout_redirect_uri: origin,
      client_secret: 'replaceMe',
      //test: autoLogoffTimeout,
      metadata: {
        issuer: `${baseUrl}/oauth2/token`,
        authorization_endpoint: `${baseUrl}/oauth2/authorize`,
        userinfo_endpoint: `${baseUrl}/oauth2/userinfo`,
        end_session_endpoint: `${baseUrl}/oidc/logout`,
        jwks_uri: `${baseUrl}/oauth2/jwks`,
        token_endpoint: `${baseUrl}/oauth2/token`,
      }
    };
  }

  export { getUserManager, setupUserManager, getSettings };
